import { Component, Input } from '@angular/core';

import { ITableColumn } from '../../shared/table/table.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-final-paper-document-files',
    templateUrl: './final-paper-document-files.component.html'
})
export class FinalPaperDocumentFilesComponent {
    constructor(
        private modal: NgbActiveModal
    ) { }

    @Input() title: string;
    @Input() files: { name: string, url: string }[] = [];

    readonly columns: ITableColumn[] = [
        { label: 'finalPaperDocument_lblFile' }
    ];

    close() {
        this.modal.close();
    }
}
